import PermissionDenied from './PermissionDenied';

export default PermissionDenied;
